import { AnyAction, combineReducers } from '@reduxjs/toolkit';
import { uptimeApi } from 'core/api';
import authReducer from 'feature/auth/store';
import assetsReducer from 'feature/assets/store';
import changelogReducer from 'feature/changelog/store';
import companiesReducer from 'feature/companies/store';
import layoutReducer from 'core/layout/reducer';
import dashboardReducer from 'feature/dashboard/store';
import mapReducer from 'feature/map/store';
import maintenanceReducer from 'feature/maintenance/store';
import remoteConfigReducer from 'core/config/firebase/remote-config-slice';

const reducers = combineReducers({
  [uptimeApi.reducerPath]: uptimeApi.reducer,
  auth: authReducer,
  assets: assetsReducer,
  changelog: changelogReducer,
  companies: companiesReducer,
  dashboard: dashboardReducer,
  layout: layoutReducer,
  maintenance: maintenanceReducer,
  map: mapReducer,
  remoteConfig: remoteConfigReducer,
});

const rootReducer = (state: ReturnType<typeof reducers> | undefined, action: AnyAction) => {
  let stateRef = state;
  if (action.type === 'auth/logout') {
    stateRef = undefined;
  }
  return reducers(stateRef, action);
};
export default rootReducer;
